import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class MibemCommandInputService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }

    doGetBonCommandeAction(numBC: string) {
        return this._httpClient.get<any>(this._apiService.workspaceEndpointUrl + "/api/Mibem/doGetBonCommandeAction_Mibem/" + numBC)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors du chargement de la commande. Veuillez réessayer plus tard.'))).toPromise();
    }
}